import Home from './Pages/Home';
import { useEffect } from 'react';
import About from './Pages/about';
import Nav from './Components/navbar';
import Contact from './Pages/contact';
import RequestQuotes from './Pages/requestQuotes';
import NotFound from './Pages/notFound';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTopTwo';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// admin
import AdminLogin from "./Pages/Admin/AdminLogin";
import AdminMessages from "./Pages/Admin/AdminMessages";
import { AdminProvider } from "../src/context/AdminContext"
import AdminNewsList from './Pages/Admin/AdminNewsList';
import AdminNewsForm from './Pages/Admin/AdminNewsForm';
import AdminMain from './Pages/Admin/AdminMain';
// news
import NewsList from './Pages/News/newsList'; 
import NewsDetail from './Pages/News/newsDetail';
// products
import ProductList from './Pages/Products/ProductList';
import ProductDetail from './Pages/Products/ProductDetail';
import CalciumCarbonate from "./Pages/Products/calcium-carbonate"

function App() {
  return (
    <BrowserRouter>
      <AdminProvider>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path='/request-quotes' element={<RequestQuotes />} />
              <Route path="/:category" element={<ProductList />} />
              <Route path="/products/:category/:id" element={<ProductDetail />} />
              <Route path='/calcium-carbonate' element={<CalciumCarbonate />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin/news" element={<AdminNewsList />} />
          <Route path="/admin/news/create" element={<AdminNewsForm />} />
          <Route path="/admin/news/edit/:id" element={<AdminNewsForm />} />
          <Route path="/admin" element={<AdminMain />} />
            <Route path="*" element={<NotFound />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:id" element={<NewsDetail />} />
      </Routes>
      <Footer />
      </AdminProvider>
    </BrowserRouter>
  );
}


export default App;